import Vue from 'vue'

const responseMessage = {
  status_code: {
    '200': {
      default_message: 'Executado com sucesso.'
    },
    '201': {
      default_message: 'Criado com sucesso.'
    },
    '401': {
      default_message: 'Usuário não autenticado. Efetue o login novamente.',
      message_per_type: {
        'InvalidLoginException': 'Usuário ou senha inválido.'
      }
    },
    '400': {
      default_message: 'A solicitação não pode ser entregue ao servidor. Tente novamente.'
    },
    '404': {
      default_message: 'Registro não encontrado.'
    },
    '403': {
      default_message: 'Este usuário não está autorizado a realizar esta ação.'
    },
    '405': {
      default_message: 'A solicitação não pode ser entregue ao servidor. Tente novamente mais tarde ou contate o administrador do sistema.'
    },
    '409': {
      default_message: 'Este registro já existe.',
      message_per_type: {
        'DuplicatedUserException': 'Este usuário já está em uso.'
      }
    },
    '422': {
        default_message: 'Dados inválidos. Tente novamente.'
      },
    '500': {
      default_message: 'Deu algo de errado. Já estamos resolvendo.'
    },
    '502': {
      default_message: 'Aconteceu um probleminha, não se preocupe. Já estamos resolvendo.'
    },
  }
};

responseMessage['getMessage'] = (status_code, error_type) => {
  status_code = typeof status_code === "string" ? status_code.toString() : status_code;

  if ( responseMessage.status_code[status_code] ){
    
    if ( responseMessage.status_code[status_code]['message_per_type'] && responseMessage.status_code[status_code]['message_per_type'][error_type] ){
      return responseMessage.status_code[status_code]['message_per_type'][error_type];
    } else {
      return responseMessage.status_code[status_code]['default_message'];
    }
    
  } else {
    return 'Não foi possível realizar essa operação. Tente novamente mais tarde';
  }
}

Vue.use({
  install(Vue) {
    Vue.prototype.$respMsg = responseMessage
  }
})